document.addEventListener("DOMContentLoaded", function () {
  const mobileMenuToggle = document.querySelector(".mobile-menu-toggle");
  const mobileMenu = document.querySelector(".mobile-menu");
  const mobileMenuClose = document.querySelector(".mobile-menu-close");
  const submenuToggles = document.querySelectorAll(".mobile-submenu-toggle");

  // Mobile menu open/close
  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener("click", function () {
      mobileMenu.classList.add("active");
      document.body.style.overflow = "hidden";
      document.body.classList.add("mobile-menu-open");
    });
  }

  if (mobileMenuClose && mobileMenu) {
    mobileMenuClose.addEventListener("click", function () {
      mobileMenu.classList.remove("active");
      document.body.style.overflow = "";
      document.body.classList.remove("mobile-menu-open");
    });
  }

  // Submenu toggle functionality
  submenuToggles.forEach((toggle) => {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const submenu = this.closest(
        ".mobile-nav-link, .mobile-submenu-link"
      ).nextElementSibling;
      if (!submenu) return;

      const isActive = submenu.classList.contains("active");

      // Close all other submenus at the same level
      const siblings =
        submenu.parentElement.parentElement.querySelectorAll(".mobile-submenu");
      siblings.forEach((sib) => {
        if (sib !== submenu) {
          sib.classList.remove("active");
          const siblingToggle = sib.previousElementSibling.querySelector(
            ".mobile-submenu-toggle"
          );
          if (siblingToggle) siblingToggle.classList.remove("active");
        }
      });

      // Toggle current submenu
      submenu.classList.toggle("active");
      this.classList.toggle("active");
    });
  });

  // Close mobile menu when clicking outside
  document.addEventListener("click", function (event) {
    if (
      mobileMenu &&
      mobileMenu.classList.contains("active") &&
      !mobileMenu.contains(event.target) &&
      !(mobileMenuToggle && mobileMenuToggle.contains(event.target))
    ) {
      mobileMenu.classList.remove("active");
      document.body.style.overflow = "";
    }
  });
});
